export const getEmployeeProfileHref = (name?: string | null, locale?: string | null) => {
  return locale?.toLowerCase().startsWith('hr') ? '/o-nama/ivan-vukusic' : '/about-us/ivan-vukusic';
};
